
export default function FeatureBlocks() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Geprüfte Apps',
      description: 'Jede App wird von uns persönlich getestet. Nur bewährte Tools mit echten Auszahlungen schaffen es in unsere Liste.',
      stats: '20+ Apps getestet'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Ehrliche Reviews',
      description: 'Keine gesponserten Bewertungen. Wir zeigen dir die Wahrheit - mit Screenshots, Auszahlungsbeweisen und echten Erfahrungen.',
      stats: '100% unabhängig'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Echte Beweise',
      description: 'Screenshots von Auszahlungen, Einnahmen-Tracking und transparente Dokumentation aller Earning-Methoden.',
      stats: '1.000 EUR + dokumentiert'
    },
    {
      icon: 'ri-time-line',
      title: 'Aktuelle Updates',
      description: 'Earning-Apps ändern sich schnell. Wir halten dich auf dem Laufenden über neue Chancen und tote Links.',
      stats: 'Täglich aktualisiert'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Warum EarnProof?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            In einer Welt voller Fake-Gurus und leerer Versprechungen bringen wir Transparenz und echte Beweise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-6 hover:border-teal-400/50 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-teal-400 to-cyan-400 rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-xl text-gray-900`}></i>
              </div>
              
              <h3 className="text-xl font-semibold text-white mb-3">
                {feature.title}
              </h3>
              
              <p className="text-gray-400 mb-4 leading-relaxed">
                {feature.description}
              </p>
              
              <div className="text-teal-400 font-semibold text-sm">
                {feature.stats}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
